<template>
    <label :for="id" :class="getLabelClass()">{{ label }}</label>
    <div class="p-inputgroup">
        <Dropdown v-if="loading" loading placeholder="Carregando..." class="w-full md:w-14rem" />
        <Dropdown v-else-if='!loading' :id='id' :class='getDropdownClass()' :disabled='desabilita' :filter='filter'
                  :modelValue='modelValue' :optionLabel='optionLabel' :optionValue='optionValue'
                  :options='itens'
                  @blur="$emit('blur')" @change='updateValue' />
    </div>
    <small class="p-error" v-if="temErro">{{ this.mensagemErro || '&nbsp;'
    }}</small>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: false,
            default: '',
        },
        filter: {
            type: Boolean,
            default: false,
        },
        desabilita: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: [String, Number],
            default: '',
        },
        mensagemErro: {
            type: String,
            default: '',
        },
        temErro: {
            type: Boolean,
            default: false,
        },
        itens: {
            type: Array,
            default: () => [],
        },
        optionLabel: {
            type: [String, Function],
            default: 'label',
        },
        optionValue: {
            type: [String, Function],
            default: 'id',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        updateValue(event) {
            this.$emit('update:modelValue', event.value);
        },
        getDropdownClass() {
            return {
                'p-invalid': this.temErro,
            };
        },
        getLabelClass() {
            return {
                'error-field-label': this.temErro,
                'required': this.required,
            };
        },
    },
}
</script>